export default {
  foodVouchers: [],
  foodVoucherReviews: [],
};
